/**
 * Created by Prodaja1 on 12.5.2017..
 */
import { Component } from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';
import { Question4 } from '../question4/question4';
import {UserData} from "../services/UserData";
import { AlertController } from 'ionic-angular';

@Component({
    selector: 'question3',
    templateUrl: 'question3.html'
})
export class Question3 {
    userData: UserData;
    constructor(public navCtrl: NavController, navParams: NavParams, private alertCtrl: AlertController) {
        this.userData = navParams.data;
    }

    // checkGradesValues () {
    //     if (this.userData.answer3 == '') {
    //         let alert = this.alertCtrl.create({
    //             title: 'Error',
    //             subTitle: 'Please fill in the field',
    //             buttons: ['OK']
    //         });
    //         alert.present();
    //     }
    //     else {
    //         this.navCtrl.push(Question4, this.userData);
    //     }
    // }

    checkCommentInput() {
        if (this.userData.answer3a!="Nezadovoljni") {
            this.userData.answer3b = '';
            return true;
        }
        else {
            return false;

        }
    }

    checkGradesValues () {
        if (this.userData.answer3a=='')
        {
            let alert = this.alertCtrl.create({
                title: 'Error',
                subTitle: 'Please select one of the options',
                buttons: ['OK']
            });
            alert.present();
        }
        else { //ako je oznaceno nesto od bulleta provjeri je li oznacen not satisfied.. Ako je onda je komentar obavezan, a ako nije onda ide na sljedecu stranicu
            if (this.userData.answer3a=='Nezadovoljni') {
                if (this.userData.answer3b=='') {
                    let alert = this.alertCtrl.create({
                        title: 'Error!',
                        subTitle: 'Please state a reason',
                        buttons: ['OK']
                    });
                    alert.present();
                }
                else {
                    this.navCtrl.push(Question4, this.userData);
                }
            }
            else {
                this.navCtrl.push(Question4, this.userData);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/question3/question3.ts